import { mod } from './internal.js';
export const unixNow = () => ~~(Date.now() / 1000);
export const utcDate = () => {
    const d = new Date();
    const year = `${d.getUTCFullYear()}`;
    const month = `${d.getUTCMonth() + 1}`.padStart(2, '0');
    const date = `${d.getUTCDate()}`.padStart(2, '0');
    return year + month + date;
};
export const isLeapYear = (year) => (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
export const daysInMonth = (year, month) => {
    const modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return (modMonth === 1 ?
        isLeapYear(year) ? 29
            : 28
        : 31 - ((modMonth % 7) % 2));
};
//# sourceMappingURL=misc.js.map